export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormTratta.vue?vue&type=template&id=0de405f9&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/FormTratta.vue?vue&type=template&id=0de405f9&
// module id = 759
// module chunks = 0